import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { NotificationService } from 'app/_services/notification.service';
import { BillingSupplierService } from '../../billing-supplier.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';

import { BillingSupplierDetail } from '../../_models/billingSupplierDetail';
import { BillingSupplierData } from '../../_models/billingSupplierData';
import { HoldingPaymentType } from 'app/_models/holdingPaymentType';
import { CashbackType } from 'app/_models/_enums/cashbackType.enum';

declare const isEmpty: any;

@Component({
    selector: 'app-billing-supplier-detail', templateUrl: './billing-supplier-detail.component.html', styleUrls: ['./billing-supplier-detail.component.scss'],
    standalone: false
})
export class SupportBillingSupplierDetailComponent {
    @ViewChild('templateBillingSupplierDetail') template: TemplateRef<any>;
    holdingCashbackInfoList: BillingSupplierDetail[];
    filteredHoldingCashbackInfoList: BillingSupplierDetail[];

    modalRef: BsModalRef;
    holdingName: string;
    holdingPaymentType: HoldingPaymentType;
    holdingPaymentTypeDescription: string;

    orderValueSum: number;
    comissionPayableValueSum: number;
    cashbackValueSum: number;
    totalValueSum: number;

    private _filterValue: string;

    get HoldingPaymentTypeEnum(): typeof HoldingPaymentType {
        return HoldingPaymentType;
    }

    get CashbackTypeEnum(): typeof CashbackType {
        return CashbackType;
    }

    constructor(private billingSupplierService: BillingSupplierService, private notificationService: NotificationService, private ngxLoader: NgxUiLoaderService, private modalService: BsModalService) {}

    async close(): Promise<void> {
        this.modalRef.hide()
    }

    filterHoldingCashbackInfoList() {
        if (isEmpty(this.holdingCashbackInfoList))
            return [];

        if (isEmpty(this._filterValue))
            return this.holdingCashbackInfoList;

        var term: string = this._filterValue.toLowerCase();

        return this.holdingCashbackInfoList.filter(holding => {
            return holding.orderId.toString().startsWith(term)
                || holding.quotationId.toString().startsWith(term)
                || holding.repairerName.toLowerCase().startsWith(term);
        });
    }

    handleFilter() {
        this.filteredHoldingCashbackInfoList = this.filterHoldingCashbackInfoList();
    }

    handleTotalsLoad(holdingCashbackInfoList: BillingSupplierDetail[]): void {
        this.cashbackValueSum = holdingCashbackInfoList.reduce((acc, item) => acc + item.cashbackValue, 0);
        this.orderValueSum = holdingCashbackInfoList.reduce((acc, item) => acc + item.orderValue, 0);
        this.comissionPayableValueSum = holdingCashbackInfoList.reduce((acc, item) => acc + item.comissionPayable, 0);
        this.totalValueSum = holdingCashbackInfoList.reduce((acc, item) => acc + item.total, 0);
    }

    open(selectedHolding: BillingSupplierData): void {
        this.holdingCashbackInfoList = [];
        this.filter = '';
        this.holdingName = selectedHolding.holdingName;
        this.holdingPaymentType = selectedHolding.paymentType;
        this.holdingPaymentTypeDescription = selectedHolding.paymentTypeDescription;

        let options: ModalOptions = { class: 'holding-cashback-info-modal', backdrop: 'static', keyboard: false };
        this.modalRef = this.modalService.show(this.template, options);

        this.ngxLoader.startLoader('loader-supplier-cashback-info');

        this.billingSupplierService.getSupplierDetail(selectedHolding.holdingId).subscribe({
            next: (response: ApiResponseModel<BillingSupplierDetail[]>) => {
                if (response.result.length <= 0) {
                    this.close();
                    this.ngxLoader.stopLoader('loader-supplier-cashback-info');
                    this.notificationService.showWarningToastr('support.faturamento-fornecedores.billing-detail.message.warning.load', { translateMessage: true });
                }

                this.holdingCashbackInfoList = response.result;
                this.handleTotalsLoad(this.holdingCashbackInfoList);
                this.handleFilter();

                this.ngxLoader.stopLoader('loader-supplier-cashback-info');
            },
            error: error => {
                console.log(error);
                this.close();
                this.ngxLoader.stopLoader('loader-supplier-cashback-info');
                this.notificationService.showErrorToastr('support.faturamento-fornecedores.billing-detail.message.error.load', { translateMessage: true });
            }
        });
    }

    get filter() {
        return this._filterValue;
    }

    set filter(value) {
        this._filterValue = value;
        this.handleFilter();
    }
}
